import { createSlice } from "@reduxjs/toolkit";
import { CREATE_MEMBER_STATE, MEMBER_LIST_STATE } from "../../state";

const createMemberSlice = createSlice({
  name: "CREATE_MEMBER_SLICE",
  initialState: CREATE_MEMBER_STATE,
  reducers: {
    startCreateMember: (state) => {
      state.createMemberLoading = true;
      state.createMemberError = null;
    },
    successCreateMember: (state, action) => {
      state.createMemberLoading = false;
      state.createMember = action.payload;
    },
    errorCreateMember: (state, action) => {
      state.createMemberLoading = false;
      state.createMemberError = action.payload;
    },
  },
});

const getMemberListSlice = createSlice({
  name: "GET_MEMBER_LIST_SLICE",
  initialState: MEMBER_LIST_STATE,
  reducers: {
    startGetMember: (state) => {
      state.memberListLoading = true;
      state.memberListError = null;
    },
    successGetMember: (state, action) => {
      state.memberListLoading = false;
      state.memberList = action.payload;
    },
    errorGetMember: (state, action) => {
      state.memberListLoading = false;
      state.memberListError = action.payload;
    },
  },
});

export const { startCreateMember, successCreateMember, errorCreateMember } =
  createMemberSlice.actions;
export const { startGetMember, successGetMember, errorGetMember } =
  getMemberListSlice.actions;

export const createMemberReducer = createMemberSlice.reducer;
export const getMemberReducer = getMemberListSlice.reducer;
